
import requests from '../utils/request'

// 发布商机
export const createcompany = (data)=>{
    return requests({
        url:'/buyer/business/company/create',
        method:'post',
        data
    })
}

//更新商机
export const updatacompany = (data)=>{
    return requests({
        url:'/buyer/business/company/update',
        method:'post',
        data
    })
}

// 公司列表
export const  companyList =()=>{
    return requests({
      url:'/buyer/business/company/list',
      method :'get',
    })
  }

  // 上传图片&目录
export const  uploadInfo = (data)=>{
    return  requests({
         url:'/upload/uploadFile',
         method :'post',
         headers: {
            'Content-Type': 'multipart/form-data'
         },
         data
     })
}

// 获取标签类型
export function findChildsByKey(data) {
    return requests({
      url: '/common/sysDict/findChildsByKey?key='+data,
      method: 'get',
      data
    });
}



// 产品类型
export function findCategoryAll() {
    return requests({
      url: '/manage/business/category',
      method: 'get',
    });
}


